import { type Locale } from '@/i18n/config';
import { ptBRTranslations } from '@/i18n/translations/pt-BR';
import {
  type FlattenTranslationKeys,
  type TranslationNamespace as TranslationNamespaceType,
  type TranslationPathValue,
  type TranslationTree,
} from '@/i18n/types';

export const translations: Record<Locale, TranslationTree> = {
  'pt-BR': ptBRTranslations,
};

/** Every valid translation key, derived from the reference locale. */
export type TranslationKey = FlattenTranslationKeys<typeof ptBRTranslations>;
export type TranslationNamespace = TranslationNamespaceType<typeof ptBRTranslations>;
export type TranslationFileKey<Namespace extends TranslationNamespace> = FlattenTranslationKeys<
  TranslationPathValue<typeof ptBRTranslations, Namespace>
>;
